import { CurrencyCode } from 'types/currency';

export const REFUND_SUPPORTED_MERCHANT_CURRENCIES: readonly CurrencyCode[] = [
  CurrencyCode.USD,
  CurrencyCode.EUR,
  CurrencyCode.MXN,
  CurrencyCode.BRL,
  CurrencyCode.COP,
];

export function isRefundSupportedMerchantCurrency(mainFiatCurrency?: string | null): boolean {
  if (!mainFiatCurrency) {
    return false;
  }

  return REFUND_SUPPORTED_MERCHANT_CURRENCIES.includes(mainFiatCurrency as CurrencyCode);
}
